import { useTranslate as _useTranslate } from "@refinedev/core";

export const useTranslate = () => {
  return _useTranslate();
};
